import { ColumnDef, createColumnHelper } from '@tanstack/react-table'
import React from 'react'
import TenantName from '../../../helper/TenantName'
import { Dropdown } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import RuleChain from '../../../../shared/models/rule-chain.model'
import DebugMode from './DebugMode'
import Flex from '../../../../components/common/Flex'
import { ActionRowProps } from '../../../../components/kopiliot-list/type'

const getColumnsForTableRuleChain = (actionRows: ActionRowProps[]) => {
  const columnHelper = createColumnHelper<RuleChain>()
  const columns: ColumnDef<RuleChain, string>[] = [
    columnHelper.accessor((row) => row.id?.id, {
      id: 'id',
      cell: (info) => info.getValue(),
      header: () => 'Id',
      enableSorting: true,
    }),
    columnHelper.display({
      id: 'name',
      header: () => 'Nom',
      enableSorting: true,
      meta: {
        className: 'align-middle',
      },
      cell: (props) => {
        const { id, name } = props.row.original

        return (
          <h5 className={'mb-0 fs-10'}>
            <Link to={id ? `${id.id}` : '#'} className={'fw-semibold'}>
              {name}
            </Link>
          </h5>
        )
      },
    }),
    columnHelper.accessor((row) => row.description, {
      id: 'description',
      cell: (info) => info.getValue(),
      header: () => 'Description',
      enableSorting: true,
    }),
    columnHelper.display({
      id: 'isDebugMode',
      cell: (props) => {
        const ruleChain = props.row.original
        return (
          <div className={'text-center'}>
            <DebugMode isDebugMode={ruleChain.debugMode} />
          </div>
        )
      },
      header: () => 'Debug Mode',
    }),
    columnHelper.display({
      id: 'tenant',
      cell: (props) => {
        return (
          <>
            <TenantName tenantId={props.row.original.tenantID.id} />
          </>
        )
      },
      header: () => 'Tenant',
    }),
    columnHelper.display({
      id: 'actions',
      cell: (props) => {
        const ruleChainID = props.row.original.id?.id
        return (
          <>
            {actionRows && ruleChainID && (
              <Dropdown className={'text-center btn-reveal-trigger'}>
                <Dropdown.Toggle
                  size={'sm'}
                  className={'btn-reveal'}
                  variant="falcon-default"
                  id="dropdown-assets-actions"
                >
                  <FontAwesomeIcon icon={'ellipsis-h'} />
                </Dropdown.Toggle>

                <Dropdown.Menu
                  popperConfig={{ strategy: 'fixed' }}
                  renderOnMount={true}
                >
                  {actionRows.map((item) => {
                    return (
                      <Dropdown.Item
                        className={`text-${item.color || 'primary'}`}
                        key={item.title}
                        onClick={() => {
                          if (item.onClick) {
                            item.onClick(ruleChainID)
                          }
                        }}
                      >
                        <FontAwesomeIcon
                          icon={item.icon}
                          className="fs-0 me-2"
                        />
                        {item.title}
                      </Dropdown.Item>
                    )
                  })}
                </Dropdown.Menu>
              </Dropdown>
            )}
          </>
        )
      },
      header: () => 'Actions',
    }),
  ]
  return columns
}

const defaultRuleChainActionsRow = (
  onDeleteItem: (id: string) => void,
  onEditItem: (id: string) => void
) => {
  const actionRows: ActionRowProps[] = [
    {
      title: 'Edit',
      icon: 'edit',
      color: 'warning',
      onClick: onEditItem,
    },
    {
      title: 'Delete',
      icon: 'trash',
      color: 'danger',
      onClick: onDeleteItem,
    },
  ]
  return actionRows
}

export { getColumnsForTableRuleChain, defaultRuleChainActionsRow }
